import { useState } from "react";
import "./App.css";
import Components from "./components/components";
import Form from "./components/Form/Form";
//For every component in Components => a button that when pressed will display that component inside App (in the browser)
function App() {
  const Components_array = Object.entries(Components);
  const [current_component, set_component_to] = useState(
    Components_array[0][0]
  );
  const [is_hidden, set_hidden_to] = useState(true);

  const Components_JSX_Array = Components_array.map(
    ([Component_Name, Component_JSX]) => {
      return (
        <button
          style={{
            background: "none",

            border: `white ${
              current_component === Component_Name ? "solid 2px" : "solid 1px"
            }`,
            color: "white",
            margin: "0.4rem",
            marginBlock: "0.2rem",
          }}
          id={Component_Name + " JSX"}
          onClick={function change_component() {
            set_component_to(Component_Name);
          }}
        >
          {Component_Name}
        </button>
      );
    }
  );
  const Component = Components[current_component];
  console.log(Component);
  return (
    <div className="App">
      <div
        onClick={function hide_sidebar() {
          set_hidden_to(!is_hidden);
        }}
        style={{
          color: "white",
          width: "1.2rem",
          height: "1.2rem",
          borderRadius: "100%",
          border: "1px solid white",
          position: "fixed",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          left: is_hidden ? 0 : "4.7rem",
          top: "1.8rem",
          cursor: "pointer",
          userSelect: "none",
          zIndex: 100,
          backdropFilter: "blur(4px)",
        }}
      >
        {is_hidden ? "" : "X"}
      </div>
      <div
        style={{
          height: "100vh",
          width: is_hidden ? "0%" : "10%",
          display: "flex",
          flexDirection: "column",
          borderRight: "1px solid white",
          position: "fixed",
          overflow: "hidden",
          backgroundColor: "black",
          zIndex: 2,
        }}
      >
        <div
          style={{
            width: "100%",
            color: "white",
            marginTop: "0.2rem",
            paddingBottom: "0.2rem",
            marginBottom: "0.2rem",
          }}
        >
          Component Tester
        </div>
        {Components_JSX_Array}
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          width: "100vw",
        }}
      >
        <div style={{ width: "100%", height: "100%", overflowX: "scroll" }}>
          <Form
            fields={{
              title: { textarea: false },
              description: { textarea: true },
            }}
          />
        </div>

        {/*<Components.Login/>*/}
      </div>
    </div>
  );
}

export default App;
